import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded px-2.5 py-1.5 text-sm font-medium leading-none capitalize",
  {
    variants: {
      variant: {
        default:     "border border-foreground/20 text-foreground",
        tertiary:    "bg-foreground/5 text-foreground",
        destructive: "bg-destructive/15 text-destructive",
        success:     "bg-success/15 text-success",
        warning:     "bg-warning/15 text-warning",
        info:        "bg-info/15 text-info",
      },
    },
    defaultVariants: { variant: "default" },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
